module.exports = __webpack_public_path__ + "static/img/aepic-9.6d32b41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-9.jpg
// module id = XnTI
// module chunks = 52